import React from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import MemoryChargedForm from './MemoryChargedForm';
import AlternateMemoryChargedForm from './AlternateMemoryChargedForm';
import DigitalChargedForm from './DigitalChargedForm';
import {
    starSetMemoryCharged,
    starSetAlternateMemoryCharged,
    starSetDigitalCharged,
    getMemoryCharged,
    starGetMemoryCharged,
    getAlternateMemoryCharged,
    getDigitalCharged
} from '../../actions/memoryCharged';
import { createMemoryCharged } from '../../api/api';
import _ from 'lodash';
import Loader from '../Loader';
import { pushToDataLayer } from '../../utils/gtmUtils';

class MemoryChargedPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: 0,
            tabs: [
                {
                    id: 0,
                    name: '1. Chargé de mémoire'
                },
                {
                    id: 1,
                    name: '2. Chargé de mémoire suppléant'
                },
                {
                    id: 2,
                    name: '3. Chargé numérique'
                },

            ],
            promiseIsResolved: false,
            propsCharged: false
        };
    }

    componentWillMount() {
        const self = this;
        let memoryChargedData = {};
        this.props.starGetMemoryCharged(this.props.beneficiary.idBeneficiaire, this.props.partenaireData.id).then((response) => {
            self.setState({ data: response.data, promiseIsResolved: true });
            if (_.find(response.data, { role: "memoryCharged" })) {
                memoryChargedData = _.find(response.data, { role: "memoryCharged" });
            }
            const alternateMemoryChargedData = _.find(response.data, { role: "alternateMemoryCharged" });
            const digitalChargedData = _.find(response.data, { role: "digitalCharged" });
            memoryChargedData.toogle = !memoryChargedData.toogle;
            this.props.getMemoryCharged(memoryChargedData);
            if (alternateMemoryChargedData) {
                this.props.getAlternateMemoryCharged(alternateMemoryChargedData);
            } else {
            	const alternateMemoryChargedDefaultState = {
            		    dateNaissance: null,
            		    prenom: '',
            		    nom: '',
            		    address: '',
            		    zipCode: '',
            		    city: '',
            		    codeCountry : '',
            		    idBeneficiaire:'',
            		    email:'',
            		    telephone:'',
            		    alternateCharged : '1'
            		};
            	this.props.getAlternateMemoryCharged(alternateMemoryChargedDefaultState);
            }
            if (digitalChargedData) {
                this.props.getDigitalCharged(digitalChargedData);
            } else {
            	const digitalChargedDefaultState = {
            		    dateNaissance: null,
            		    prenom: '',
            		    nom: '',
            		    address: '',
            		    zipCode: '',
            		    city: '',
            		    digitalCharged: '',
            		    facebook : '',
            		    twitter : '',
            		    codeCountry : '',
            		    idBeneficiaire:'',
            		    email:'',
            		    telephone:'',
            		    profils:'',
            		    addDigitalCharged : '0'
            		};
            	this.props.getDigitalCharged(digitalChargedDefaultState);
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.memoryChargedData !== this.props.memoryChargedData) {
            this.setState({
                propsCharged: true
            });
        }
    }

    selectTab = (selected) => {
        this.setState({ selected });
    }

    goBack = (e) => {
        e.preventDefault();
        if (this.state.selected === 0) {
            this.props.history.push('/accueil');
        } else {
            this.selectTab(this.state.selected - 1);
        }
    }

    onMemoryChargedSubmit = (memoryChargedData) => {
        const dataLayer = {
            event: "principalMemoryManager",
            url: window.location.href,
            idPartenaire: this.props.partenaireData.id
        }
        pushToDataLayer(dataLayer);
        memoryChargedData.idBeneficiaire = this.props.beneficiary.idBeneficiaire;
        this.props.starSetMemoryCharged(memoryChargedData);
        this.setState(() => ({ selected: 1 }));
    };

    onAlternateMemoryChargedSubmit = (alternateMemoryChargedData) => {
        if ( alternateMemoryChargedData.alternateCharged == "1" ) {
            const dataLayer = {
                event: "alternateMemoryManager",
                url: window.location.href,
                idPartenaire: this.props.partenaireData.id
            }
            pushToDataLayer(dataLayer);
        }
        alternateMemoryChargedData.idBeneficiaire = this.props.beneficiary.idBeneficiaire;
        this.props.starSetAlternateMemoryCharged(alternateMemoryChargedData);
        this.setState(() => ({ selected: 2 }));
    };



    onDigitalChargedSubmit = (digitalChargedData) => {
        digitalChargedData.idBeneficiaire = this.props.beneficiary.idBeneficiaire;
        this.props.starSetDigitalCharged(digitalChargedData);
        this.createMemoryWorkers({
            dateNaissance: digitalChargedData.date,
            prenom: digitalChargedData.firstName,
            nom: digitalChargedData.name,
            address: digitalChargedData.address,
            zipCode: digitalChargedData.zipCode,
            city: digitalChargedData.city,
            email: digitalChargedData.email,
            telephone: digitalChargedData.telephone,
            digitalCharged: digitalChargedData.digitalCharged,
            facebook: digitalChargedData.facebook,
            twitter: digitalChargedData.twitter,
            codeCountry: digitalChargedData.codeCountry,
            idBeneficiaire: digitalChargedData.idBeneficiaire,
            profils: digitalChargedData.profils,
            role: 'digitalCharged',
            addDigitalCharged: digitalChargedData.addDigitalCharged,
            mission: digitalChargedData.mission
        });
        this.setState(() => ({ selected: 3 }));
    };
    createMemoryWorkers = (digitalChargedData) => {
        const dataLayer = {
            event: "memoryChargedSave",
            url: window.location.href,
            idPartenaire: this.props.partenaireData.id
        }
        pushToDataLayer(dataLayer);

        let array = [];
        if (this.props.memoryChargedData !== "") {
            array.push(this.props.memoryChargedData);
        }
        if (this.props.alternateMemoryChargedData.alternateCharged !== "0") {
            array.push(this.props.alternateMemoryChargedData);
        }
        if (digitalChargedData.addDigitalCharged !== "0") {
            array.push(digitalChargedData);
        }

        createMemoryCharged(array, this.props.partenaireData.id).then((response) => {
            this.props.history.push('/accueil');
        }).catch((error) => {
            console.log('error', error);
        });
    }

    render() {
        if (!this.state.promiseIsResolved) { return null }
        return (
            <div className="memory-page container main-container">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Accueil</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">Mes chargés de mémoire</li>
                </ol>
                <h1 className="text-center">Mes chargés de mémoire</h1>
                <div className="intro-text">
                    Désignez dès maintenant les personnes qui devront respecter vos volontés.
                </div>
                <ul className="tab-list">
                    {
                        this.state.tabs.map((tab, i) =>
                            <li
                                key={i}
                                className={this.state.selected === tab.id ? 'tab-item active' : 'tab-item'}
                            // onClick={() => this.selectTab(tab.id)}
                            >
                                {tab.name}
                            </li>
                        )
                    }
                </ul>
                {this.state.propsCharged ?
                    <div>
                        {this.state.selected === 0 && this.state.data &&
                            <MemoryChargedForm
                                onMemoryChargedSubmit={this.onMemoryChargedSubmit}
                                back={this.goBack}
                            />}
                        {this.state.selected === 1 &&
                            <AlternateMemoryChargedForm
                                onAlternateMemoryChargedSubmit={this.onAlternateMemoryChargedSubmit}
                                back={this.goBack}
                            />}
                        {this.state.selected === 2 &&
                            <DigitalChargedForm
                                onDigitalChargedSubmit={this.onDigitalChargedSubmit}
                                serverDigitalChargedData={this.props.digitalChargedData}
                                memoryChargedData={this.props.memoryChargedData}
                                alternateMemoryChargedData={this.props.alternateMemoryChargedData}
                                back={this.goBack}
                            />}
                    </div>
                    :
                    <Loader />
                }

            </div>
        )
    }

}

const mapDispatchToProps = (dispatch) => ({
    starSetMemoryCharged: (memoryChargedData) => dispatch(starSetMemoryCharged(memoryChargedData)),
    starSetAlternateMemoryCharged: (alternateMemoryChargedData) => dispatch(starSetAlternateMemoryCharged(alternateMemoryChargedData)),
    starSetDigitalCharged: (digitalChargedData) => dispatch(starSetDigitalCharged(digitalChargedData)),
    starGetMemoryCharged: (benef, partner) => dispatch(starGetMemoryCharged(benef, partner)),
    getMemoryCharged: (memoryChargedReturned) => dispatch(getMemoryCharged(memoryChargedReturned)),
    getAlternateMemoryCharged: (alternateMemoryChargedData) => dispatch(getAlternateMemoryCharged(alternateMemoryChargedData)),
    getDigitalCharged: (digitalChargedData) => dispatch(getDigitalCharged(digitalChargedData)),
});

const mapStateToProps = (state) => ({
    memoryChargedData: state.memoryChargedData,
    alternateMemoryChargedData: state.alternateMemroyChargedData,
    digitalChargedData: state.digitalChargedData,
    beneficiary: state.beneficiaryData.idBeneficiaire ? state.beneficiaryData : JSON.parse(sessionStorage.getItem('benef')),
    partenaireData: state.partenaireData
});

export default connect(mapStateToProps, mapDispatchToProps)(MemoryChargedPage);




// WEBPACK FOOTER //
// ./src/components/MemoryChargedPage/MemoryChargedPage.js